import { baseApi } from './baseApi'
import tokenService from '../../services/tokenService'
import {
  requestStarted,
  requestFailed,
  authSucceeded,
  profileSet,
  profileCleared,
} from '../slices/authSlice'

function extractMutationError(rejection, fallback) {
  const data = rejection?.error?.data
  return data?.detail || data?.message || rejection?.error?.message || fallback
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        data: body,
        _skipAuth: true,
      }),
      invalidatesTags: ['Auth'],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        dispatch(requestStarted())
        try {
          const { data } = await queryFulfilled
          tokenService.setTokens(data)
          dispatch(authSucceeded())
          dispatch(
            authApi.endpoints.fetchProfile.initiate(undefined, {
              forceRefetch: true,
            }),
          )
        } catch (err) {
          dispatch(
            requestFailed(
              extractMutationError(err, 'Unable to sign in. Please try again.'),
            ),
          )
        }
      },
    }),

    signup: builder.mutation({
      query: (body) => ({
        url: '/auth/register',
        method: 'POST',
        data: body,
        _skipAuth: true,
      }),
      invalidatesTags: ['Auth'],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        dispatch(requestStarted())
        try {
          const { data } = await queryFulfilled
          tokenService.setTokens(data)
          dispatch(authSucceeded())
          dispatch(
            authApi.endpoints.fetchProfile.initiate(undefined, {
              forceRefetch: true,
            }),
          )
        } catch (err) {
          dispatch(
            requestFailed(
              extractMutationError(
                err,
                'Unable to create account. Please try again.',
              ),
            ),
          )
        }
      },
    }),

    fetchProfile: builder.query({
      query: () => ({ url: '/auth/profile', method: 'GET' }),
      providesTags: ['Auth'],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(profileSet(data))
        } catch {
          dispatch(profileCleared())
        }
      },
    }),
  }),
})

export const {
  useLoginMutation,
  useSignupMutation,
  useFetchProfileQuery,
  useLazyFetchProfileQuery,
} = authApi
